import { useAuth } from '@hourly/contexts/AuthContext';
import { useRequest } from '@hourly/hooks/useRequest';
import { useState } from 'react';
import {
  FederalTaxClassification,
  Partner,
  TaxPayerIdentificationType,
} from './models/partner.model';
import { getPartner, updatePartner as updatePartnerRequest } from './requests/partner.request';

export interface PartnerUpdateArgs {
  id: string;
  legalName: string;
  dba?: string | null;
  federalTaxClassification: FederalTaxClassification;
  taxpayerIdentificationType: TaxPayerIdentificationType;
  taxpayerIdentificationNumber: string;
  firstName: string;
  lastName: string;
  address: string;
  address2?: string | null;
  city: string;
  state: string;
  zipCode: string;
}

export const usePartner = (partnerId: string, callback: (partner: Partner) => void) => {
  const {
    sessionState: { userId: partnerUserId },
  } = useAuth();

  const [partner, setPartner] = useState<Partner | null>(null);

  useRequest(
    async () => {
      const partner = await getPartner(partnerId, partnerUserId!);
      setPartner(partner);
      callback(partner);
    },
    { requestOnMount: true }
  );

  const { request: updatePartner, status: updatePartnerStatus } = useRequest(
    async (partner: Partial<PartnerUpdateArgs> & { id: string }) => {
      await updatePartnerRequest(partner);
    },
    {
      onError: (_, { triggerGlobalNotifyError }) => {
        triggerGlobalNotifyError();
      },
    }
  );

  return {
    partner,
    isUpdatePartnerLoading: updatePartnerStatus.isLoading,
    updatePartner,
  };
};
